<template>
    <div>
        <div class="announce_div">
            <div class="announce_img">
                <img :src="announceImg">
            </div>
            <div class="announce_area"><marquee>{{announce}}严守公司经营道德红线:1.严禁飞单2.严禁做假资料3.严禁私自留存客户信息(征信报告、身份证复印件、客户名单)一经发现,严肃处理并且保留追责权利!</marquee></div>
        </div>
        <div class="sousuo" style="width: 100%">
            <div style="width: 450px" class="yl-flex flex_between">
                <Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
                    <i-button slot="append" icon="ios-search"></i-button>
                </Input>
                <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
            </div>
        </div>
        <div class="multiple">
            <div class="child-div">时间维度</div>
            <RadioGroup v-model="timeDimension" @on-change="timePeriod='0'">
				<Radio label="2"><span>申请时间</span></Radio>
				<Radio label="4"><span>实际上门时间</span></Radio>
            </RadioGroup>
        </div>
        <div class="multiple">
            <div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<div v-if="timeDimension == 1">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="3"><span>3天未跟进</span></Radio>
					<Radio label="7"><span>7天未跟进</span></Radio>
					<Radio label="14"><span>14天未跟进</span></Radio>
					<Radio label="30"><span>30天未跟进</span></Radio>
					<Radio label="60"><span>60天未跟进</span></Radio>
				</div>
				<div v-else>
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
								type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
				</div>
			</RadioGroup>
        </div>

        <div class="multiple" style="width: 100%">
            <Table :columns="columns" :data="datas" size="small" ref="table">
                <template slot-scope="{ row }" slot="name">
                    <div style="display: flex; align-items: center;">
						<div v-if="row.type == 1" style="width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">
							个
						</div>
						<div v-if="row.type == 2" style="width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">
							企
						</div>
                        <div style="display: flex;flex-direction: column; align-items: center;">
							<span>{{row.name}}</span>
							<span>{{row.phone}}</span>
                        </div>
                    </div>
                </template>

                <template slot-scope="{ row }" slot="entrust">
					<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.created_at}} {{item.ext_info.remark}}</div>
					<div v-if="row.entrust.length == 0">无</div>
                </template>
                <template slot-scope="{ row }" slot="operation">
                    <div  style="display: flex; flex-direction: column; align-items: center;justify-content: space-around; height: 60px;">
                        <span v-if="row.contract_id != 0" :data-contract_id="row.contract_id"  @click.stop="contractManage">签约管理</span>
                    </div>
                </template>
            </Table>
        </div>
        <div class="pager">
            <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
        </div>
        <!-- 查看签约管理 -->
        <Modal v-model="modal" width="900">
            <EditContract :contractId="contractId"></EditContract>
            <div slot="footer">
                <Button type="default" @click="modal = false">取消</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import Upload from '../tool/Upload.vue'
    import {
        mapActions,
        mapGetters
    } from "vuex";
	import {
        getHistoryList
	} from '@/api/client'
    import {
        getUserList,getMyClientTips,getAnnounce
    } from '@/api/user'
    import EditContract from "../task/EditContract";
    import Loan from "../task/Loan";
    export default {
        name: "HistoryCreateMoney",
        components: {EditContract, Loan},
        props: {
            menuName: {
                type: String
            }
        },
        data() {
            return {
                clientId: 0,
                contractId: 0,
                announce: '',
                announceImg: require('../../assets/images/announce.png'),
                modal: false,
                count: 0,
                page: 1,
                name: '',
                timeDimension: 0,
                timePeriod: 0,
                userList: [],
                is_add_wechat: [],
                timePeriodDate: [],
                datas: [],
                columns: [
                    {
                        "title": "跟进人",
                        "key": "follow_name",
                        "width": 60
                    },
                    {
                        "title": "客户",
                        "slot": "name",
                        "width": 60
                    },
                    {
                        "title": "星级",
                        "key": "start_name",
                        "width": 60,
                        filters: [],
                        filterMultiple: false,
                        filterMethod(value, row) {

                        }
                    },
                    {
                        "title": "媒体代码",
                        "key": "media_name",
                        "width": 80
                    },
                    {
                        "title": "需求额度",
                        "key": "loans_money",
                        "width": 70,
                        filters: [],
                        filterMultiple: false,
                        filterMethod(value, row) {

                        }
                    },
                    {
                        "title": "成交状态",
                        "key": "status_name",
                        "width": 80
                    },
                    {
                        "title": "申请时间",
                        "key": "applied_at",
                        "width": 100,
                        "sortable": true
                    },
                    {
                        "title": "上门时间",
                        "key": "view_ac_at",
                        "width": 100,
                        "sortable": true
                    },
                    {
                        "title": "签约费率",
                        "key": "rate",
                        "width": 100,
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "width": 80
                    }
                ],
            }
        },
        computed: {
            ...mapGetters(['token']),
        },
        mounted: function () {
			this.loadData();
			this.getList();
            this.getAnnounce();
        },
        methods: {
            ...mapActions([
                'handleLogOut',
            ]),
			search() {
				this.page = 1;
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
            async getAnnounce() {
                let that = this;
                var data = {token: this.token};
                let res = await getAnnounce(that, data);
                if (res.code == 1) {
                    that.announce = res.data.text;
                }
            },
			async loadData() {
				let that = this;
				that.initSearch();
				var data = {token: this.token};
				var data = {
					token: that.token
				};
				var res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
			},
            initSearch() {
                this.name = '';
                this.timeDimension = 0
                this.timePeriod = 0;
                this.timePeriodDate = [];
            },
			async getList() {
				let that = this;
				this.modal = false;
				this.loanModal = false;
				var data = this.$data;
				data.menu = this.menuName;
				data.token = this.token;
				data.page = this.page;
				let res = await getHistoryList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
            changePage(e) {
                this.page = e;
                this.getList();
            },
            contractManage(e) {
                let that = this;
                that.contractId = e.currentTarget.dataset.contract_id;
                that.modal = true;
            }
        }
    }
</script>
<style scoped lang="less">
    .hong {
        color: #F56171;
        font-weight: bold;
        cursor: pointer;
    }

    .lan {
        color: #124386;
        font-weight: bold;
        cursor: pointer;
    }

    .sousuo {
        width: 100%;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }

    /deep/ .ivu-table table {
        width: 100% !important;
    }
    /deep/ .ivu-table th{
        background: #00a0e8;
        color: white;
    }
    .announce_div{
        position: relative;
        background-color:#F2F2F2 ; color: #E8410B;margin-bottom: 20px;
    }
    .announce_img{
        position: absolute;
        left: 4px;
        img{
            width: 20px;
            height: 20px;
            margin-top: 5px;
        }
    }
    .announce_area{
        margin-left: 25px;
        overflow: hidden;
        marquee{
            margin-top: 5px;
        }
    }
</style>
